import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Spin } from "antd";
import { toast } from "react-toastify";
import { tiposNovedadesApi } from "../../services/api";

const TipoNovedadFormModal = ({ visible, onCancel, onSuccess, editingTipoNovedad }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const isEditing = !!editingTipoNovedad;

  useEffect(() => {
    if (visible && isEditing) {
      // Completar formulario con datos existentes si estamos editando
      form.setFieldsValue({
        novedad: editingTipoNovedad.novedad,
        descripcion: editingTipoNovedad.descripcion,
      });
    } else if (visible) {
      // Limpiar formulario si estamos creando
      form.resetFields();
    }
  }, [visible, editingTipoNovedad, form, isEditing]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (isEditing) {
        // Actualizar tipo de novedad existente
        await tiposNovedadesApi.update(editingTipoNovedad.id, values);
        toast.success("Tipo de novedad actualizado correctamente", {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        // Crear nuevo tipo de novedad
        await tiposNovedadesApi.create(values);
        toast.success("Tipo de novedad creado correctamente", {
          position: "top-right",
          autoClose: 4000,
        });
      }

      setLoading(false);
      onSuccess();
    } catch (error) {
      console.error("Error al guardar tipo de novedad:", error);
      let errorMsg = "Error al guardar los datos";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMsg = error.response.data.message;
      }
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 4000,
      });
      setLoading(false);
    }
  };

  return (
    <Modal
      title={isEditing ? "Editar Tipo de Novedad" : "Nuevo Tipo de Novedad"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      maskClosable={false}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="mt-4"
        >
          <Form.Item
            label="Nombre de la Novedad"
            name="novedad"
            rules={[
              {
                required: true,
                message: "Por favor ingrese el nombre de la novedad",
              },
            ]}
          >
            <Input placeholder="Ej: COMPENSATORIO" />
          </Form.Item>

          <Form.Item
            label="Descripción"
            name="descripcion"
            rules={[
              {
                required: true,
                message: "Por favor ingrese una descripción",
              },
            ]}
          >
            <Input.TextArea 
              placeholder="Ej: DIA COMPENSATORIO" 
              autoSize={{ minRows: 3, maxRows: 6 }}
            />
          </Form.Item>

          <div className="flex justify-end gap-2 mt-6">
            <Button onClick={onCancel}>Cancelar</Button>
            <Button
              type="primary"
              htmlType="submit"
              className="bg-blue-600 hover:bg-blue-700"
            >
              {isEditing ? "Actualizar" : "Crear"}
            </Button>
          </div>
        </Form>
      </Spin>
    </Modal>
  );
};

export default TipoNovedadFormModal;